module.exports = __webpack_public_path__ + "static/media/no-stopping.345478cd.png";